import { render, staticRenderFns } from "./SelectType.vue?vue&type=template&id=58cd48c5"
import script from "./SelectType.vue?vue&type=script&lang=js"
export * from "./SelectType.vue?vue&type=script&lang=js"
import style0 from "./SelectType.vue?vue&type=style&index=0&id=58cd48c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports